module.exports = __webpack_public_path__ + "media/images/sad-bus-2ee56470e450f8cc298413cd23f3b3d8.png";